import { connect } from "react-redux";
import React, { Component } from 'react';
import { Rect } from 'react-konva';

class WaveformSelection extends Component {
    render() {
        return (
           <Rect
             x={this.props.start}
             y={0}
             width={this.props.end - this.props.start}
             height={this.props.height} fill='yellow'/>);
    }
}

const mapStateToProps = (state, props) => {
    if (state.selector.waveformSelection === undefined) {
        return {};
    }

    if (state.selector.waveformSelection.id !== props.sampleId) {
        return {};
    }

    return {
        start: state.selector.waveformSelection.start,
        end: state.selector.waveformSelection.end,
    };
};

export default connect(mapStateToProps, null)(WaveformSelection);

